import React, {useEffect, useState} from 'react';
import {Redirect, Route} from "react-router";
import {RegisterForm} from "./register-form";
import {ResetPasswordStep1} from "./reset-password-step-1";
import {ResetPasswordStep2} from "./reset-password-step-2";
import {RegisterConfirmForm} from "./register-confirm-form";
import {LoginForm} from "./login-form";
import {Auth} from "aws-amplify";

export function AuthScreen() {
    return (
        <div>
            <Route path="/login" component={LoginForm}/>
            <Route path="/register" component={RegisterForm}/>
            <Route path="/registerconfirm" component={RegisterConfirmForm}/>
            <Route path="/forgotpassword1" component={ResetPasswordStep1}/>
            <Route path="/forgotpassword2" component={ResetPasswordStep2}/>
        </div>
    );
}

export function ProtectedRoute({component: Component, ...rest}) {
    const [isAuthenticated, setLoggedIn] = useState(true);

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(() => setLoggedIn(true))
            .catch(() => setLoggedIn(false));
    });

    return (
        <Route {...rest} render={props =>
            isAuthenticated ? <Component {...props} /> : <Redirect to="/login"/>
        }/>
    );
}
